import { render, staticRenderFns } from "./KundenumsaetzeTabelle.vue?vue&type=template&id=4d3cdd98&scoped=true&"
import script from "./KundenumsaetzeTabelle.vue?vue&type=script&lang=js&"
export * from "./KundenumsaetzeTabelle.vue?vue&type=script&lang=js&"
import style0 from "./KundenumsaetzeTabelle.vue?vue&type=style&index=0&id=4d3cdd98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3cdd98",
  null
  
)

export default component.exports